// api/mails.js
// 授業振替に関するAPIを実装する

import Api from './api_base'

export default {
  // POST /mails/userInfo_change_notification 正規ユーザー昇格に際してのメール送信
  postUserInfoChange: (data) => {
    console.log(data)
    return Api.post('/mails/userinfo_change_notification', data)
    .catch((err) => {
      console.log(err)
      throw err
    })
  },
  // GET /mails/rescheduling_request 授業振替依頼のメールを送信する
  postReschedulingRequest: (hash) => {
    return Api.post('/mails/rescheduling_request', {hash: hash})
    .catch((err) => {
      console.log(err)
      throw err
    })
  },
  postReschedulingResult: (hash) => {
    if (!hash.newhash) {
      // mails/rescheduling_result 授業振替の調整のメールを送信する
      return Api.post('mails/rescheduling_result', {hash: hash})
      .catch((err) => {
        throw err
      })
    } else {
      // mails/rescheduling_result 授業振替の調整のメールを送信する
      return Api.post('mails/rescheduling_result', {
        hash: hash.hash,
        newhash: hash.newhash
      })
      .catch((err) => {
        throw err
      })
    }
  },
  postReschedulingError: (hash) => {
    return Api.post('mails/rescheduling_error', {hash: hash})
    .catch((err) => {
      throw err
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/mails.js